export const categories = [
  { slug: 'all', name: '全部', icon: 'ri-apps-line' },
  { slug: 'live', name: '赛事直播', icon: 'ri-live-line' },
  { slug: 'news', name: '赛事资讯', icon: 'ri-newspaper-line' },
  { slug: 'guide', name: '技巧攻略', icon: 'ri-lightbulb-line' },
  { slug: 'data', name: '数据分析', icon: 'ri-bar-chart-line' },
  { slug: 'interview', name: '人物专访', icon: 'ri-user-star-line' },
];

export const articles = [
  {
    slug: 'aoyunhui-2026-zhanbao',
    title: '2026年奥运会最新战报：中国代表团斩获多枚金牌',
    excerpt: '2026年奥运会正在如火如荼地进行中，中国代表团在多个项目中表现出色，已斩获多枚金牌。本文为您带来最新赛况分析和奖牌榜解读。',
    content: `2026年奥运会正在如火如荼地进行中，中国代表团在本届赛事中展现了强大的竞技实力。截至目前，中国代表团已在游泳、举重、射击、体操等多个传统优势项目中斩获金牌。

在游泳赛场上，中国选手表现尤为出色。女子200米蝶泳决赛中，中国选手以打破奥运会纪录的成绩夺冠，展现了强大的实力。男子100米自由泳项目中，中国队同样有亮眼表现，成功站上领奖台。

举重项目作为中国队的传统强项，本届奥运会继续保持了强劲势头。在女子49公斤级和男子61公斤级比赛中，中国选手均以绝对优势夺冠，并刷新了多项世界纪录。

射击赛场上，中国射击队的表现同样令人瞩目。在10米气步枪混合团体项目中，中国队顶住压力，在最后一枪完成逆转，成功夺得金牌。

体操项目中，中国男队在团体赛中发挥稳定，以出色的表现赢得了评委的认可。女队则在平衡木项目中表现亮眼，收获了一枚宝贵的金牌。

随着赛事的深入，中国代表团有望在田径、跳水、乒乓球等项目中继续争夺奖牌。让我们共同期待中国健儿们在接下来的比赛中再创佳绩！`,
    category: 'news',
    categoryName: '赛事资讯',
    image: 'https://readdy.ai/api/search-image?query=Olympic%20stadium%20with%20Chinese%20athletes%20competing%20in%20track%20and%20field%2C%20dramatic%20sports%20photography%2C%20warm%20golden%20lighting%2C%20crowd%20cheering%2C%20athletic%20excellence%2C%20red%20and%20gold%20color%20scheme%2C%20heroic%20composition%2C%20sports%20event%20atmosphere&width=800&height=500&seq=article-olympic-01&orientation=landscape',
    date: '2026-08-05',
    author: '大满贯编辑部',
    tags: ['奥运会', '中国代表团', '金牌', '赛事战报'],
    featured: true,
  },
  {
    slug: 'lanqiu-zhongjijuesai-huigu',
    title: 'NBA总决赛回顾：经典对决背后的战术深度解析',
    excerpt: '本赛季NBA总决赛堪称经典，两支顶级球队的对抗充满了战术博弈。本文从专业角度深度解析总决赛中的关键战术变化和球员表现。',
    content: `本赛季NBA总决赛堪称近年来最精彩的对决之一。两支顶级球队在七场系列赛中展现了极高的竞技水平和战术素养，为球迷们奉献了一场视觉盛宴。

从战术层面来看，本次总决赛的核心看点在于双方教练组的博弈。防守端，区域联防与人盯人防守的灵活切换成为了比赛的关键变量。进攻端，挡拆战术的多样化运用以及无球跑动创造的机会成为了得分的重要手段。

在球员表现方面，双方核心球员均展现出了超级巨星的实力。关键时刻的单打能力、对比赛节奏的掌控以及队友之间的默契配合，共同构成了这场经典对决的核心要素。

让我们从数据角度来回顾这场经典对决中的关键战术变化，以及这些变化如何影响了比赛的最终走向。`,
    category: 'guide',
    categoryName: '技巧攻略',
    image: 'https://readdy.ai/api/search-image?query=Professional%20basketball%20game%20in%20large%20arena%2C%20dramatic%20sports%20moment%2C%20basketball%20player%20dunking%2C%20warm%20stadium%20lights%2C%20crowd%20energy%2C%20sports%20photography%2C%20intense%20atmosphere%2C%20red%20and%20orange%20tones&width=800&height=500&seq=article-nba-02&orientation=landscape',
    date: '2026-08-03',
    author: '战术分析组',
    tags: ['NBA', '总决赛', '战术分析', '篮球'],
    featured: true,
  },
  {
    slug: 'zuqiu-bei-zhongguodui-jihua',
    title: '世界杯预选赛前瞻：中国队出线形势全面分析',
    excerpt: '世界杯亚洲区预选赛进入关键阶段，中国队面临重要考验。本文全面分析中国队出线形势、对手实力以及关键战役展望。',
    content: `世界杯亚洲区预选赛已经进入白热化阶段，中国男足正在为争取世界杯入场券而努力。本文将从多个维度全面分析中国队的出线形势。

当前积分形势：在已经进行的比赛中，中国队取得了不错的成绩，目前在小组中处于有利位置。但接下来的几场比赛将直接决定出线命运。

对手实力分析：剩余对手中，既有传统强队也有实力相当的竞争对手。我们需要针对不同对手制定相应的战术策略。

关键战役展望：接下来对阵直接竞争对手的比赛将是决定性的。中国队需要在主场拿下关键三分，同时在客场争取不败。

球员状态评估：目前球队核心球员状态良好，几名留洋球员的回归为球队增添了更多战术选择。年轻球员的成长也为球队注入了新的活力。`,
    category: 'news',
    categoryName: '赛事资讯',
    image: 'https://readdy.ai/api/search-image?query=Chinese%20national%20football%20team%20playing%20in%20stadium%2C%20soccer%20match%20with%20red%20jersey%2C%20dramatic%20lighting%2C%20sports%20photography%2C%20green%20field%2C%20passionate%20fans%2C%20international%20competition%20atmosphere&width=800&height=500&seq=article-football-03&orientation=landscape',
    date: '2026-08-01',
    author: '大满贯编辑部',
    tags: ['世界杯', '中国队', '预选赛', '足球'],
    featured: false,
  },
  {
    slug: 'dianjing-saishi-shuju-fenxi',
    title: '电竞产业大数据：2026年全球电竞赛事趋势解读',
    excerpt: '随着电竞产业持续高速发展，2026年全球电竞赛事呈现新趋势。本文通过数据分析，解读电竞赛事观众规模、商业价值和未来发展方向。',
    content: `2026年，全球电竞产业继续保持着强劲的增长势头。根据最新数据显示，全球电竞观众规模已突破6亿人次，赛事商业价值持续攀升。

在赛事规模方面，头部电竞赛事的奖金池不断刷新纪录。英雄联盟全球总决赛、DOTA2国际邀请赛等顶级赛事的关注度已经媲美传统体育赛事。

从地域分布来看，亚洲市场仍然是电竞产业的核心驱动力。中国、韩国、东南亚地区的电竞用户增长尤为显著。同时，欧美市场的电竞产业也在快速发展。

在商业模式上，电竞赛事的收入来源日益多元化。除了传统的赞助商收入和媒体版权外，虚拟商品、粉丝经济、线下场馆运营等新商业模式正在成为重要增长点。

展望未来，随着5G技术普及和元宇宙概念发展，电竞赛事的观赛体验将迎来革命性变化。VR/AR技术的应用将让观众获得更加沉浸式的观赛体验。`,
    category: 'data',
    categoryName: '数据分析',
    image: 'https://readdy.ai/api/search-image?query=Professional%20esports%20arena%20with%20large%20screens%20and%20colorful%20lights%2C%20gaming%20competition%20stage%2C%20crowd%20watching%2C%20high%20tech%20atmosphere%2C%20red%20and%20gold%20accents%2C%20modern%20esports%20venue&width=800&height=500&seq=article-esports-04&orientation=landscape',
    date: '2026-07-28',
    author: '数据分析组',
    tags: ['电竞', '数据分析', '产业趋势', '2026'],
    featured: false,
  },
  {
    slug: 'wangqiu-damanju-yundongyuan',
    title: '专访大满贯冠军：从草根到巅峰的网球之路',
    excerpt: '我们独家专访了刚刚获得大满贯冠军的中国网球选手，听他讲述从草根训练到站上世界之巅的心路历程和训练秘诀。',
    content: `在刚刚结束的网球大满贯赛事中，中国选手创造了历史，首次捧起了大满贯冠军奖杯。我们有幸独家专访了这位创造历史的选手，听他讲述那些不为人知的故事。

从六岁第一次接触网球开始，他就展现了过人的天赋。但天赋只是起点，真正的成功来自于日复一日的刻苦训练。"每天凌晨五点起床训练，这样的日子我坚持了十五年，"他回忆道。

在职业生涯初期，他经历了无数次的失败和挫折。世界排名一度跌出前100，伤病也曾让他萌生退意。但正是这些低谷，让他变得更加坚韧。

"每一次失败都是一次学习的机会。我学会了如何调整心态，如何在逆境中寻找突破。"如今，这位大满贯冠军已经成为了中国网球的标杆人物。`,
    category: 'interview',
    categoryName: '人物专访',
    image: 'https://readdy.ai/api/search-image?query=Tennis%20player%20holding%20trophy%20on%20tennis%20court%2C%20golden%20sunset%20lighting%2C%20athletic%20portrait%2C%20inspirational%20sports%20moment%2C%20warm%20tones%2C%20professional%20sports%20photography%2C%20championship%20celebration&width=800&height=500&seq=article-tennis-05&orientation=landscape',
    date: '2026-07-25',
    author: '专访组',
    tags: ['网球', '大满贯', '人物专访', '冠军之路'],
    featured: true,
  },
  {
    slug: 'zhibo-jishu-jiexi',
    title: '体育直播技术深度解析：如何实现超低延迟观赛体验',
    excerpt: '大满贯App采用先进的流媒体传输技术，实现赛事直播的超低延迟。本文深入解析背后的技术原理，带你了解高清流畅直播的实现方式。',
    content: `在体育赛事直播中，延迟问题一直是用户体验的核心痛点。大满贯App通过采用多项先进技术，成功将直播延迟控制在行业领先水平。

核心技术一：自适应码率传输。系统会根据用户的网络状况动态调整视频码率，确保在不同网络环境下都能获得流畅的观看体验。

核心技术二：边缘计算节点部署。通过在全国范围内部署边缘计算节点，大幅缩短了数据传输距离，有效降低了延迟。

核心技术三：智能预加载算法。系统会预测用户可能观看的赛事内容，提前进行数据预加载，进一步提升观看体验的流畅度。

核心技术四：多链路冗余保障。在关键赛事直播中，系统会同时建立多条传输链路，确保在任何情况下都不会出现直播中断。

这些技术的综合应用，让大满贯App的用户可以享受到近乎实时的观赛体验。`,
    category: 'guide',
    categoryName: '技巧攻略',
    image: 'https://readdy.ai/api/search-image?query=Modern%20broadcasting%20control%20room%20with%20multiple%20screens%20showing%20sports%20events%2C%20technology%20setup%2C%20professional%20studio%20environment%2C%20warm%20lighting%2C%20high%20tech%20atmosphere%2C%20sports%20production&width=800&height=500&seq=article-tech-06&orientation=landscape',
    date: '2026-07-20',
    author: '技术团队',
    tags: ['直播技术', '低延迟', '流媒体', '技术解析'],
    featured: false,
  },
  {
    slug: 'saishi-zhibiao-tuijie',
    title: '2026下半年不容错过的十大体育赛事盘点',
    excerpt: '2026年下半年全球体育赛事精彩纷呈，从网球大满贯到足球世界杯预选赛，本文为您盘点最值得关注的十大体育赛事。',
    content: `2026年下半年，全球体育赛事精彩纷呈。我们为您精心挑选了十大不容错过的体育赛事，涵盖足球、篮球、网球、田径等多个热门项目。

1. 网球美国公开赛（8月底-9月初）：年度最后一项大满贯赛事，全球顶尖选手齐聚纽约。

2. 男篮世界杯（8月-9月）：全球篮球强国的巅峰对决，中国队力争佳绩。

3. 世界田径锦标赛（9月）：田径项目的最高舞台，众多世界纪录有望被刷新。

4. 亚运会（9月-10月）：亚洲最大的综合性体育赛事，中国代表团全力出击。

5. 世界杯亚洲区预选赛（持续进行）：中国队冲击世界杯的关键战役不容错过。

6. 英雄联盟全球总决赛（10月-11月）：电竞界的"世界杯"，全球数亿观众关注。

7. F1赛季收官战（11月-12月）：速度与激情的终极较量。

8. 英超联赛（8月开赛）：新赛季英超战火重燃。

9. NBA新赛季（10月开赛）：新赛季NBA期待更多精彩。

10. 年终ATP总决赛（11月）：男子网坛年终巅峰对决。`,
    category: 'news',
    categoryName: '赛事资讯',
    image: 'https://readdy.ai/api/search-image?query=Collage%20of%20various%20sports%20events%2C%20stadium%20panorama%2C%20athletes%20in%20action%2C%20golden%20hour%20lighting%2C%20dynamic%20sports%20composition%2C%20warm%20and%20vibrant%20colors%2C%20sports%20photography&width=800&height=500&seq=article-events-07&orientation=landscape',
    date: '2026-07-15',
    author: '大满贯编辑部',
    tags: ['赛事盘点', '2026', '体育赛事', '观赛指南'],
    featured: false,
  },
  {
    slug: 'yundong-kangfu-zhinan',
    title: '运动康复完全指南：科学训练避免运动伤害',
    excerpt: '运动损伤是每位运动爱好者都可能面临的问题。本文邀请专业运动康复师，为您详细讲解如何科学训练、有效预防运动伤害。',
    content: `无论是专业运动员还是业余爱好者，运动损伤都是不可忽视的问题。我们邀请了资深运动康复师，为您带来这份实用的运动康复完全指南。

运动前的科学热身：充分的热身是预防运动损伤的第一道防线。建议进行10-15分钟的全身性热身，包括动态拉伸和轻度有氧运动。

训练中的注意事项：保持正确的动作姿势至关重要。特别是在进行力量训练时，错误的姿势不仅影响训练效果，更可能导致严重的运动损伤。

常见运动损伤的自我处理：对于轻微的肌肉拉伤和扭伤，可以采用RICE原则（休息、冰敷、压迫、抬高）进行初步处理。

运动后的恢复策略：充分的休息和营养补充是运动恢复的关键。建议在训练后进行适当的静态拉伸，并保证充足的睡眠。`,
    category: 'guide',
    categoryName: '技巧攻略',
    image: 'https://readdy.ai/api/search-image?query=Professional%20sports%20physiotherapy%20and%20rehabilitation%20setting%2C%20athlete%20doing%20stretching%20exercises%2C%20warm%20natural%20lighting%2C%20medical%20and%20fitness%20environment%2C%20clean%20modern%20clinic%2C%20sports%20medicine&width=800&height=500&seq=article-recovery-08&orientation=landscape',
    date: '2026-07-10',
    author: '健康专栏',
    tags: ['运动康复', '训练指导', '运动伤害', '健康'],
    featured: false,
  },
];